import React from 'react';

import './title-card.css';
import '../grid.css';

export default function TitleCard() {
  return (
    <div className="hero" id="hero">
      <h1 className="tome-title">Tome</h1>
      <p className="tagline">What do you want to read next?</p>
    </div>
  );
}







// WEBPACK FOOTER //
// ./src/components/title-card.js